import * as React from 'react';
import { SVGProps } from 'react';

const SvgMessageNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 16H4V4h10.1a5 5 0 0 1 0-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V6.98c-.58.44-1.26.77-2 .92V16z" />
    <path d="M19 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6H6v2h8v-2zm4-3H6v2h12V9zM6 8h12v-.1A5.013 5.013 0 0 1 15.03 6H6v2z" />
  </svg>
);

export default SvgMessageNotification;
